<template>
    <div class="buttons">
        <button @click="printHtml" class="print no_print" title="Печатная версия">
            <span><i class="uk-icon-print"></i></span>
        </button>
        <button @click="downloadPdf" class="pdf no_print" title="Скачать в PDF">
            <span><i class="uk-icon-file-pdf-o"></i></span>
        </button>
    </div>
</template>

<script>
export default {
    props: {
        html: { type: String },
        title: { type: String },
        filename: {
            type: String,
            default: 'lic_download'
        },
        printStyle: {
            type: String,
            default: ''
        }
    },
    methods: {
        downloadPdf() {
            this.$store.dispatch('downloadPDF', {
                html: this.$props.html,
                title: this.$props.title,
                filename: `${this.$props.filename}.pdf`,
                style: this.$props.printStyle,
                target: 'tile' 
            })
        },
        printHtml() {
            this.$store.dispatch('printHTML', {
                title: this.$props.title,
                html: this.$props.html,
                style: this.$props.printStyle
            })
        }
    }
}
</script>

<style lang="sass" scoped>
@import '../../../../styles/global-variables'

.buttons
    width: 65px
    display: flex
    .print, .pdf
        @include tile-button()
    .print
        border-top-right-radius: 0
        border-bottom-right-radius: 0
        margin-right: -1px
    .pdf
        border-top-left-radius: 0
        border-bottom-left-radius: 0            
</style>